import clsx from 'clsx';
import PropTypes from 'prop-types';

import Tag, {renderTagIfPresent} from 'components/Tag/index';
import logger from 'conf/Logger';

import './OtherGuidance.scss';


const propTypes = {
  context: PropTypes.oneOf(['guideline', 'guidelineAnnotation', 'label', 'labelAnnotation']).isRequired,
  showHelp: PropTypes.bool,
  className: PropTypes.string,
};

export default function OtherGuidanceTag({context, showHelp = true, className}) {
  const props = {
    className: clsx('otherGuidanceTag', className),
  };
  if (showHelp) {
    if (context === 'guideline' || context === 'guidelineAnnotation') {
      props.tooltipUrl = '/page/clinicalGuidelineLegend#clinical-guideline-annotation-tags';
    } else if (context === 'label' || context === 'labelAnnotation') {
      props.tooltipUrl = '/page/drugLabelLegend#drug-label-annotation-tags';
    } else if (context === 'pgxAssociation') {
      props.tooltipUrl = '/page/fdaPGxTableLegend';
    } else {
      logger.error(`context must be either "guidelineAnnotation" or "labelAnnotation", got "${context}"`);
      return <div className="text-danger">error - check console</div>;
    }
    props.tooltipText = 'Learn more about the Other Guidance tag';
  }
  return (
    <Tag {...props}>Other Guidance</Tag>
  );
}
OtherGuidanceTag.propType = propTypes;


export function renderOtherGuidanceTag({obj, showHelp, className}) {
  return renderTagIfPresent({
    tag: OtherGuidanceTag,
    obj,
    dbProp: 'otherPrescribingGuidance',
    indexProp: 'other-prescribing-guidance',
    showHelp,
    className,
  });
}
